// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"958db822","239":"4e331f58","453":"97e539b4","455":"8800cdf8"}[chunkId] + ".chunk.js";
};